import DemoNavbar from "components/Navbars/DemoNavbar";
import Sidebar from "components/Sidebar/Sidebar";
import { routes } from "../../routes/routes";
import React, { useState } from "react";
import { Col, Row } from "reactstrap";
import imgPrincipal from "../../assets/avantSolar/Seguidores/seguidores_r4_planta.jpg";
import imgEstructura from "../../assets/avantSolar/Seguidores/seguidores_r4_estructura.jpg";
import imgTecnologia from "../../assets/avantSolar/Seguidores/seguidores_r4_tecnologia.jpg";
import Footer from "components/Footer/Footer";
import CaracteristicasGenerales from "./seguidores/caracteristicasGenerales";
import Rentabilidad from "./seguidores/rentabilidad";
import Estructura from "./seguidores/estructura";
import Tecnologia from "./seguidores/tecnologia";
import Especificaciones from "./seguidores/especificaciones";
import { Helmet } from "react-helmet-async";

function Seguidores(props) {
  const [image, setImage] = useState(imgPrincipal);
  const [componente, setComponente] = useState(CaracteristicasGenerales);
  const [nombreComponente, setNombreComponente] = useState(
    CaracteristicasGenerales.name
  );

  const setElementos = (image, componente) => {
    setImage(image);
    setComponente(componente);
    setNombreComponente(componente.name);
  };
  return (
    <>
      <Helmet>
        <title>Seguidores</title>
        <meta
          name="description"
          content="Seguidor solar de un eje azimutal, giro de este a oeste con una inclinación fija de 15° al sur."
        />
        <meta name="robots" content="all" />
      </Helmet>
      <div className="wrapper">
        <Sidebar {...props} routes={routes} />
        <div className="main-panel h-100">
          <div>
            <DemoNavbar {...props} hideTitle />

            <Row className="">
              <Col xs={12} sm={6} md={5} xl={5} className=" p-0 fondoColumna">
                <div className="linea1 helpHeaderLine">
                  <Row>
                    <Col xs={1}>
                      <div className="linea2 h-100 p-3"></div>
                    </Col>
                    <Col>
                      <div className="d-flex justify-content-center flex-column align-items-center p-2">
                        <h1 className="p-0 m-0 h4 font-weight-bold">
                          AVANTTRACKER 15
                        </h1>
                        <p className="p-0 m-0 text-light h6">
                          SEGUIDORES DE UN EJE AZIMUTAL
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="p-5">
                  <p>
                    Seguidor solar de un eje azimutal, giro de este a oeste con
                    una inclinación fija de 15° al sur.
                  </p>
                  {componente && (
                    <ul className="seguidoresList">
                      <li
                        className={`${
                          nombreComponente == "CaracteristicasGenerales"
                            ? "selectedSeguidores"
                            : ""
                        } p-1`}
                        onClick={() => {
                          setElementos(imgPrincipal, CaracteristicasGenerales);
                        }}
                      >
                        {"> "}Características Generales
                      </li>

                      <li
                        className={`${
                          nombreComponente == "Rentabilidad"
                            ? "selectedSeguidores "
                            : ""
                        }p-1`}
                        onClick={() => {
                          setElementos(imgPrincipal, Rentabilidad);
                        }}
                      >
                        {"> "}Rentabilidad
                      </li>

                      <li
                        className={`${
                          nombreComponente == "Estructura"
                            ? "selectedSeguidores "
                            : ""
                        }p-1`}
                        onClick={() => {
                          setElementos(imgEstructura, Estructura);
                        }}
                      >
                        {"> "}Estructura
                      </li>

                      <li
                        className={`${
                          nombreComponente == "Tecnologia"
                            ? "selectedSeguidores "
                            : ""
                        }p-1`}
                        onClick={() => {
                          setElementos(imgTecnologia, Tecnologia);
                        }}
                      >
                        {"> "}Tecnología
                      </li>

                      <li
                        className={`${
                          nombreComponente == "Especificaciones"
                            ? "selectedSeguidores "
                            : ""
                        }p-1`}
                        onClick={() => {
                          setElementos(imgPrincipal, Especificaciones);
                        }}
                      >
                        {"> "}Especificaciones
                      </li>
                    </ul>
                  )}
                  <p className="text-right">Folleto AvantTracker 15</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={7} xl={7} className="p-0">
                <div className="linea1 helpHeaderLine d-none d-sm-block"></div>
                <div className="p-5 d-flex justify-content-center">
                  <img
                    draggable="false"
                    className="imgSeguidores"
                    src={image}
                  ></img>
                </div>
              </Col>
            </Row>
            {componente}
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
}

export default Seguidores;
